<template>
  <v-card flat data-aos="fade">

    <v-app-bar
      class="hidden-sm-and-down"
      fixed
      height="69px"
      color="white"
      extension-height="190"
    >
      <v-btn-toggle group>
        <v-btn text plain :to="{name: 'about'}">About</v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn plain text
              v-on="on"
              :to="{name: 'work-with-me'}"
            >
              Work With Me
            </v-btn>
          </template>
          <v-list class="services-menu">
            <v-list-item
              v-for="(item, index) in services"
              :key="index"
              :to="item.to"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn plain text
              v-on="on"
              :to="{name: 'events'}"
            >
              Events
            </v-btn>
          </template>
          <v-list class="services-menu">
            <v-list-item
              v-for="(item, index) in events"
              :key="index"
              :to="item.to"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-btn plain text
              v-on="on"
              :to="{name: 'shop'}"
            >
              Shop
            </v-btn>
          </template>
          <v-list class="services-menu">
            <v-list-item
              v-for="(item, index) in shop"
              :key="index"
              :to="item.to"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn-toggle group>
        <v-btn plain text to="/blog">Blog</v-btn>
        <v-btn text plain :to="{name: 'gallery'}">Gallery</v-btn>
        <v-btn plain text to="/contact">Contact</v-btn>
      </v-btn-toggle>
    </v-app-bar>

    <v-app-bar
      class="brand-nav hidden-sm-and-down"
      fixed
      height="69px"
      color="white"
      extension-height="190"
      flat
      width="300px"
    >
      <v-spacer></v-spacer>
      <v-btn
        active-class="brand"
        class="brand"
        plain
        text
        to="/"
      >Chef Naturelle
      </v-btn>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-app-bar
      class="hidden-md-and-up mt-0"
      fixed
      height="69px"
      color="white"
      extension-height="190"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title class="brand">
        <v-btn
          active-class="brand"
          class="brand"
          text
          depressed
          plain
          to="/"
        >Chef Naturelle</v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      fixed
      floating
      temporary
    >
      <v-list>
        <v-list-item>
          <v-spacer></v-spacer>
        </v-list-item>

        <v-list-item exact :to="{name: 'home'}">
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{name: 'about'}">
          <v-list-item-content>
            <v-list-item-title>About</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Work With Me</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            dense
            exact
            :to="{'name': 'services'}"
          >
            <v-list-item-content>
              <v-list-item-title>All</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            dense
            v-for="(service, i) in services"
            :key="i"
            :to="service.to"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="service.title"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Shop</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            dense
            exact
            :to="{'name': 'shop'}"
          >
            <v-list-item-content>
              <v-list-item-title>All</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item
            dense
            v-for="(event, i) in events"
            :key="i"
            :to="event.to"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="event.title"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item
            dense
            v-for="(item, i) in shop"
            :key="i"
            :to="item.to"
          >
            <v-list-item-content>
              <v-list-item-title
                v-text="item.title"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item to="/blog">
          <v-list-item-content>
            <v-list-item-title>Blog</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/gallery">
          <v-list-item-content>
            <v-list-item-title>Gallery</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/contact">
          <v-list-item-content>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import {
  VAppBar,
  VAppBarNavIcon,
  VCard,
  VBtn,
  VBtnToggle,
  VList,
  VListGroup,
  VListItem,
  VListItemContent,
  VListItemTitle,
  VMenu,
  VNavigationDrawer,
  VSpacer,
  VToolbarTitle,
} from 'vuetify/lib'

export default {
  components: {
    VAppBar,
    VAppBarNavIcon,
    VCard,
    VBtn,
    VBtnToggle,
    VList,
    VListGroup,
    VListItem,
    VListItemContent,
    VListItemTitle,
    VMenu,
    VNavigationDrawer,
    VSpacer,
    VToolbarTitle,
  },
  data: () => ({
    drawer: false,
    events: [
      {
        title: 'Cooking Workshops',
        to: {name: 'cooking-workshops'},
      },
      {
        title: 'Events',
        to: {name: 'events-events'},
      },
      {
        title: 'Holistic Retreats',
        to: {name: 'holistic-retreats'},
      },
      {
        title: 'Supperclubs',
        to: {name: 'supperclubs'},
      },
    ],
    shop: [
      {
        title: 'Events',
        to: {name: 'events'},
      },
      {
        title: 'E-books',
        to: {name: 'ebooks'},
      },
      {
        title: 'Online Learning',
        to: {name: 'online-learning'},
      },
    ],
    services: [
      {
        title: 'Retreat Catering',
        to: {name: 'retreat-catering'},
      },
      {
        title: 'Event Catering',
        to: {name: 'event-catering'},
      },
      {
        title: 'Cooking Classes',
        to: {name: 'cooking-classes'},
      },
      {
        title: 'Personal Chef',
        to: {name: 'personal-chef'},
      },
      {
        title: 'Collaborations',
        to: {name: 'collaborations'},
      },
    ],
  })
}
</script>

<style lang="scss" scoped>
.brand-nav {
  margin: 0 auto;
}

.brand {
  font-size: 24px !important;
  letter-spacing: normal !important;
  text-align: center;
}

.services-menu {
  text-transform: uppercase;
}

.v-toolbar__extension .v-list {
  padding: 0;
}

.v-list {
  padding-top: 0;
}

.v-list__tile {
  font-size: 18px;
}
</style>
